import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Dashboard, ECommerce } from "../../../../Constants/Constants";
import TotalSales from "./TotalSales/TotalSales";
import ManageOrder from "./ManageOrder/ManageOrder";
import OrderThisMonth from "./OrderThisMonth/OrderThisMonth";
import ProductDelivery from "./ProductDelivery/ProductDelivery";
import OurGoalOverview from "./OurGoalOverview/OurGoalOverview";
import RecentCustomers from "./RecentCustomers/RecentCustomers";
import OrderThisMonthTwo from "./OrderThisMonthTwo/OrderThisMonthTwo";
import RecentOrders from "./RecentOrders/RecentOrders";

const ECommerceContainer = () => {
  return (
    <>
      <Breadcrumbs parent={Dashboard} mainTitle={ECommerce} />
      <Container fluid className="dashboard_ecommerce">
        <Row className="size-column">
          <TotalSales />
          <ManageOrder />
          <OrderThisMonth />
          <ProductDelivery />
          <OurGoalOverview />
          <RecentCustomers />
          <OrderThisMonthTwo/>
          <RecentOrders/>
        </Row>
      </Container>
    </>
  );
};

export default ECommerceContainer;
